import { Injectable } from '@angular/core';
import { RuntimeConfigService } from './runtime-config.service';

@Injectable({
  providedIn: 'root',
})
export class DemoModeService {
  constructor(private runtimeConfigService: RuntimeConfigService) {}

  get isDemoMode$() {
    return this.runtimeConfigService.isDemoMode$;
  }

  get isDemoMode(): boolean {
    return this.runtimeConfigService.isDemoMode;
  }

  async enableDemoMode(): Promise<void> {
    await this.runtimeConfigService.enableDemoMode();
  }

  async disableDemoMode(): Promise<void> {
    await this.runtimeConfigService.disableDemoMode();
  }
}